const arsFormatter = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  maximumFractionDigits: 0,
});

const numberFormatter = new Intl.NumberFormat('es-AR');

export function formatARS(value: number): string {
  return arsFormatter.format(value);
}

export function formatKm(km: number): string {
  return km === 0 ? '0 km' : `${numberFormatter.format(km)} km`;
}
